<template>
  <div>
    <div class="main-title">体检记录</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button icon="el-icon-edit-outline" type="primary" @click="formVisible = true">添加体检记录</el-button>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :disabled="user.buttons.indexOf(1020) < 0"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索学员姓名或身份证"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchParams)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <batch-search @search="batSearch"></batch-search>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-button style="margin-bottom:10px" v-if="selectRows.length > 0" @click="multiPrint">打印单据</el-button>
      <el-table
        ref="table"
        :data="list"
        stripe
        border
        :height="tableHeight"
        :summary-method="getSummaries"
        show-summary
        @selection-change="handleSelectionChange"
        style="width:100%">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column
          prop="id"
          label="编号"
          width="70">
        </el-table-column>
        <el-table-column
          prop="school_name"
          label="所属驾校"
          width="100"
          v-if="user.group_id !== 1">
        </el-table-column>
        <el-table-column
          prop="name"
          label="学员姓名"
          width="100">
        </el-table-column>
        <el-table-column
          prop="idcard"
          label="身份证号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="exam_time"
          label="体检时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="exam_fee"
          label="体检费"
          width="70">
        </el-table-column>
        <el-table-column
          label="打印收据"
          width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="printBill(scope.row)">打印收据</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="70">
          <template slot-scope="scope">
            <el-button type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加体检记录表单 -->
    <el-dialog title="添加体检记录" :visible.sync="formVisible">
      <el-form :model="form" ref="form" :rules="formRules" label-width="200px">
        <el-form-item label="所属驾校" v-if="user.group_id !== 1">
          <el-select
            v-model="form.school_id"
            placeholder="请选择驾校"
            filterable
            style="width:194px;">
            <el-option label="无" :value="0"></el-option>
            <el-option
              v-for="item in schoolList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学员姓名" prop="name">
          <el-input v-model="form.name">
            <el-button slot="append" @click="readIdcard">读身份证</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="证件号码">
          <el-input v-model="form.idcard">
            <el-button slot="append" @click="readIdcard">读身份证</el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="体检费" prop="exam_fee">
          <el-input v-model="form.exam_fee"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="startCommit" :loading="startCommiting">确 定</el-button>
        <el-button @click="formVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import BatchSearch from './BatchSearch'
import moment from 'moment'
import _ from 'lodash'
export default {
  mixins: [ListFunc, DatePickerOptions],
  components: {
    BatchSearch
  },
  data () {
    return {
      sqlcode: 'physical_list',
      searchForm: {
        query: '',
        idcard_guid: '',
        daterange: this.user.buttons.indexOf(1020) < 0 ? [new Date(), new Date()] : []
      },
      formVisible: false,
      form: {
        school_id: 0,
        name: '',
        idcard: '',
        exam_fee: 20,
        remark: ''
      },
      formRules: {
        name: [
          { required: true, message: '请输入学员姓名', trigger: 'blur' }
        ],
        exam_fee: [
          { required: true, message: '请输入体检费', trigger: 'blur' },
          
        ]
      },
      startCommiting: false,
      idcardReading: false,
      schoolList: []
    }
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return this.searchForm
      } else {
        return {
          query: this.searchForm.query,
          idcard_guid: this.searchForm.idcard_guid,
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  mounted () {
    this.fetchSchoolList()
  },
  methods: {
    batSearch (guid) { // 批量搜索
      console.log(guid)
      this.searchForm.idcard_guid = guid
      this.search(this.searchParams)
    },
    fetchSchoolList () { // 获取驾校列表
      this.$http.get('/dbapi/school_combo').then(response => {
        if (response.data.success) {
          this.schoolList = response.data.list
        }
      })
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        const values = data.map(item => Number(item[column.property]))
        if (column.property === 'exam_fee') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
        } else if (column.property === 'name') {
          sums[index] = '合计'
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    startCommit: _.throttle( // 提交体检记录
      function () {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.startCommiting = true
            this.$http.post('/dbapi/physical_new', this.form).then(response => {
              this.startCommiting = false
              if (response.data.success) {
                this.formVisible = false
                this.form.name = ''
                this.form.idcard = ''
                this.refresh()
              } else {
                this.$message({
                  type: 'error',
                  message: response.data.message
                })
              }
            })
          }
        })
      },
      1000
    ),
    readIdcard () { // 读身份证
      this.idcardReading = true
      this.$idcard.read().then(data => {
        this.idcardReading = false
        this.form.name = data.name
        this.form.idcard = data.code
      }).catch(() => {
        this.idcardReading = false
      })
    },
    printBill (row) {
      window.open(this.$http.receiptBaseUrl + '/physical_print?id=' + row.id + '&token=' + localStorage.getItem('kaochang.token'))
    },
    multiPrint () {
      let ids = ''
      for (var i = 0; i < this.selectRows.length; i++) {
        ids += '&ids=' + this.selectRows[i].id
      }
      window.open(this.$http.receiptBaseUrl + '/physical_print_ids?token=' + localStorage.getItem('kaochang.token') + ids)
    },
    del (row) {
      this.$confirm(`确定要删除这条记录吗？[${row.name}]`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/del_physical', {
          id: row.id
        }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    }
  }
}
</script>

<style>
.bill-info .el-alert__title {
  font-size: 16px;
}
.bill-info .el-alert__description {
  font-size: 14px;
}
.bill-info {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/physical/Index.vue